import React from "react";

import { useDesktopMediaQuery } from "../../../utils/helpers";

import styles from "./productSearch.module.css";
import { ProductSearchProps } from "../types";
import { useShopContext } from "../../../context/ShopContext";
import ICONS from "../../constants/icons";
import { useRouter } from "next/router";
import ProductSearchActiveFilters from "./productSearchActiveFilters";

const useProductSearch = () => {};

let debouncedTimer;

const ProductSearch = ({ activeFilters, onClickIcon }: ProductSearchProps) => {
  const { productTags, variantOptions } = useShopContext();
  const router = useRouter();

  const updateSearch = (searchVal) => {
    // Throttle this
    router.query.s = searchVal;
    router.push(router, undefined, {
      scroll: false,
      shallow: true, // tell next that it doesnt need to refresh all the data when navigation
    });
  };

  const searchChangeEvent = (ev) => {
    clearInterval(debouncedTimer);

    const val = ev.currentTarget.value;

    debouncedTimer = setTimeout(() => {
      updateSearch(val);
    }, 300);
  };

  return (
    <div className={styles.container}>
      <div className={styles.searchInput}>
        <input
          type="text"
          placeholder="Search"
          onChange={searchChangeEvent}
          className={styles.searchInput}
          defaultValue={router.query.s}
        />
        <div onClick={onClickIcon}>
          <ICONS.SEARCH size={16} />
        </div>
      </div>
      <ProductSearchActiveFilters activeFilters={activeFilters} />

      {/* <div className={styles.filterButton}>Search</div> */}
      {/* <div className={styles.sortButton}>Sort By</div> */}
    </div>
  );
};

export default ProductSearch;
